import { FunctionComponent } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useLocalization } from 'Hooks';
import { getCookiePolicyUrl } from 'Utils';
import { CookiePreferences } from 'Hooks/useCookieConsent';
import './CookieConsentBanner.scss';

interface CookieConsentBannerProps {
  onCustomize: () => void;
  onAcceptAll: () => void;
  onRejectAll: () => void;
  isVisible: boolean;
  onSavePreferences: (preferences: CookiePreferences) => void; // Parent'tan bunu almamız ŞART
}

const CookieConsentBanner: FunctionComponent<CookieConsentBannerProps> = ({
  onCustomize,
  onAcceptAll,
  onRejectAll,
  isVisible,
  onSavePreferences,
}) => {
  // useLocalization() CMS verisi Redux'a yüklenene kadar undefined döner; banner App
  // kökünde ilk render'da (init datadan önce) mount olduğundan doğrudan destructure
  // tüm ağacı çökertiyordu (beyaz ekran). Optional access ile güvene alındı; CMS gelince
  // useSelector aboneliği yeniden render edip URL'i doldurur.
  // URL'i tutan asıl key `...Link`'tir; bazı CMS kitaplarında doğrudan base key'de de
  // gelebildiğinden ikisi de getCookiePolicyUrl ile değerlendirilir (sadece geçerli
  // http(s) adresi açılır, "Çerez Politikası" etiket metni açılmaz).
  const cmsKeys = useLocalization();
  const cookiePolicyUrl = getCookiePolicyUrl(
    cmsKeys?.belbim_cookie_cerezPolitikasiLink,
    cmsKeys?.belbim_cookie_cerezPolitikasi,
  );

  if (!isVisible) return null;

  const handlePolicyClick = () => {
    if (cookiePolicyUrl) {
      window.open(cookiePolicyUrl, '_blank', 'noopener,noreferrer');
    }
  };

  // --- GARANTİLİ KAYDETME FONKSİYONLARI ---
  const handleForceAcceptAll = () => {
    onSavePreferences({ essential: true, performance: true, marketing: true });
    onAcceptAll();
  };

  const handleForceRejectAll = () => {
    onSavePreferences({ essential: true, performance: false, marketing: false });
    onRejectAll();
  };

  return (
    <Box className="cookie-consent-banner">
      <Box className="banner-content">
        <Box className="banner-text">
          <Typography variant="h6" component="h1" className="banner-title">
            Gizliliğinize değer veriyoruz
          </Typography>
          <Typography variant="body2" component="p" className="banner-description">
            Göz atma deneyiminizi geliştirmek, kişiselleştirilmiş reklamlar veya içerik sunmak ve trafiğimizi analiz 
            etmek için çerezler kullanıyoruz. "Tümünü Kabul Et"e tıklayarak, çerez kullanımımıza onay verirsiniz.{' '}
            <Typography
              component="span"
              className="policy-link"
              role="link"
              tabIndex={0}
              onClick={handlePolicyClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handlePolicyClick();
                }
              }}
            >
              Çerez Politikası
            </Typography>
          </Typography>
        </Box>

        <Box className="banner-actions">
          <Button onClick={handleForceRejectAll} className="btn-reject">
            Tümünü Reddet
          </Button>
          <Button onClick={onCustomize} className="btn-customize" variant="outlined">
            Tercihlerimi Yönet
          </Button>
          <Button onClick={handleForceAcceptAll} className="btn-accept" variant="contained" color="primary">
            Tümünü Kabul Et
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CookieConsentBanner;